import { extend, configure } from "vee-validate";
import { required, email, min, size, regex, mimes, ext, numeric, dimensions  } from "vee-validate/dist/rules";
import i18n  from "./i18n";

configure({
    defaultMessage: (field, values) => {
        // override the field name.
        //values._field_ = i18n.t(`fields.${field}`);

        return i18n.t(`validation.${values._rule_}`);
    }
});

// Install required rule and message.
extend("required", required);
extend("email", email);
extend("min", min);
extend("size", size);
extend("mimes", mimes);
extend("url", regex);
extend("regex", regex);
extend("ext", ext);
extend("tel", regex);

extend("numeric", numeric);
extend('under_200', {
    validate: value => {
        if (value.split(' ').length > 200){
           return false
        }
        else{
            return true
        }
        ;
    }
});

extend('maxdimensions', {
    validate(file, [width, height]) {
        const validateImage = (file, width, height) => {
            const URL = window.URL || window.webkitURL;
            return new Promise(resolve => {
                const image = new Image();
                image.onerror = () => resolve( false);
                image.onload = () => resolve(
                    image.width > image.height  // only change from official rule
                );
                image.src = URL.createObjectURL(file);
            });
        };


        return validateImage(file, width, height)
            .then(
                function (value) {
                    return value
                }
            )
            .catch(
                function (value) {
                    return false
                }
            )
    }
});

